import { Action } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { State } from 'shared/interface';
import { createAction, handleAddOverflow, handleRemoveOverflow } from 'shared/util/utility';
import * as actionTypes from '../store/action-types';

const modalClose = (modalOpen: boolean) => {
	return async (dispatch: ThunkDispatch<{}, {}, Action>) => {
		handleRemoveOverflow();
		dispatch(createAction(actionTypes.MODAL_OPEN, { isModalOpen: modalOpen }));
	};
};

const modalOpen = (modalOpen: boolean) => {
	return async (dispatch: ThunkDispatch<{}, {}, Action>) => {
		handleAddOverflow();
		dispatch(createAction(actionTypes.MODAL_CLOSE, { isModalOpen: modalOpen }));
	};
};

export const setModalContent = (
	children: React.ReactNode,
	settings?: {
		modalClass?: string;
		onClose?: () => void;
	},
) => {
	return async (dispatch: ThunkDispatch<{}, {}, Action>) => {
		dispatch(createAction(actionTypes.SET_MODAL_CONTENT, { children, settings }));
	};
};

export const isModalOpen = (state: State): boolean => {
	return state.modal?.isModalOpen ?? false;
};

export { modalClose, modalOpen };
